module.exports = __webpack_public_path__ + "static/media/empty-report.e795f7e4.png";